import { GamoraFoundationError } from '../foundation/error/error.js';

/**
 * Assertion error
 * @type Error
 */
export class GamoraErrorAssertion extends GamoraFoundationError {
  constructor(message?: string) {
    super(message);
  }
}
